var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M15.75 4.5h-4.875l-1.95-1.462a1.13 1.13 0 0 0-.675-.225H5.063a1.125 1.125 0 0 0-1.125 1.124v1.126H2.812a1.125 1.125 0 0 0-1.124 1.125v7.875a1.125 1.125 0 0 0 1.125 1.124h10.75a1.064 1.064 0 0 0 1.062-1.062v-1.187h1.188a1.064 1.064 0 0 0 1.062-1.063v-6.25A1.125 1.125 0 0 0 15.75 4.5m-2.25 9.563H2.813V6.187H6l2.1 1.576a.56.56 0 0 0 .338.112H13.5zm2.25-2.25h-1.125V7.874A1.125 1.125 0 0 0 13.5 6.75H8.625l-1.95-1.463A1.13 1.13 0 0 0 6 5.063h-.937V3.938H8.25l2.1 1.575a.56.56 0 0 0 .338.112h5.062z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsMove);
export default __webpack_public_path__ + "static/media/actions-move.dc515639c41a712268f3528432da597d.svg";
export { ForwardRef as ReactComponent };